import { useImmerAtom } from 'jotai-immer';
import { tableViewAtom, tableFiltersAtom, tableStatsAtom, feedsDataAtom } from '../feeds_list_atoms';
import { FeedsDataHook } from '../feeds_list_types';
import { useTableData } from '../../../../core/table/hooks/useTableData';

export const useFeedsData = (): FeedsDataHook => {
    const [view] = useImmerAtom(tableViewAtom);
    const [filters] = useImmerAtom(tableFiltersAtom);
    const [stats, setStats] = useImmerAtom(tableStatsAtom);
    const [data] = useImmerAtom(feedsDataAtom);

    const { items } = useTableData({
        view,
        filters,
        stats,
        data,
        setStats,
    });

    return { items, rawDataSize: data.dataItems.length };
};
